export const GIORNI = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];
export const MESI = ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"];
// Ordine Python weekday(): 0 = lunedì
export const WEEKDAYS = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"];

const p2 = (n) => String(n).padStart(2, "0");
const toDate = (iso) => { const [y, m, d] = iso.split("-").map(Number); return new Date(Date.UTC(y, m - 1, d)); };
const toIso = (d) => `${d.getUTCFullYear()}-${p2(d.getUTCMonth() + 1)}-${p2(d.getUTCDate())}`;

export const addDays = (iso, n) => { const d = toDate(iso); d.setUTCDate(d.getUTCDate() + n); return toIso(d); };
export const jsDay = (iso) => toDate(iso).getUTCDay();
export const pyWeekday = (iso) => (jsDay(iso) + 6) % 7;
export const fmtShort = (iso) => { const d = toDate(iso); return `${d.getUTCDate()} ${MESI[d.getUTCMonth()]}`; };
export const fmtDay = (iso) => `${GIORNI[jsDay(iso)]} ${fmtShort(iso)}`;
export const fmtLong = (iso) => { const d = toDate(iso); return `${d.getUTCDate()} ${MESI[d.getUTCMonth()]} ${d.getUTCFullYear()}`; };
export const crossesMidnight = (slot) => slot.end_time <= slot.start_time;

export function romeToday() {
  const parts = Object.fromEntries(new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Rome", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }).formatToParts(new Date()).map((p) => [p.type, p.value]));
  return { date: `${parts.year}-${parts.month}-${parts.day}`, time: `${parts.hour}:${parts.minute}` };
}

export function monthRange(offset = 0) {
  return monthOf(romeToday().date, offset);
}

export function monthOf(iso, offset = 0) {
  const [y, m] = (iso || romeToday().date).split("-").map(Number);
  const first = new Date(Date.UTC(y, m - 1 + offset, 1));
  const last = new Date(Date.UTC(y, m + offset, 0));
  return { from: toIso(first), to: toIso(last) };
}

export function daysBetween(from, to) {
  const out = [];
  for (let d = from; d <= to && out.length < 400; d = addDays(d, 1)) out.push(d);
  return out;
}

export function groupByWeek(items, getDate = (x) => x.date) {
  const weeks = [];
  items.forEach((it) => {
    const mon = addDays(getDate(it), -pyWeekday(getDate(it)));
    let w = weeks[weeks.length - 1];
    if (!w || w.monday !== mon) { w = { monday: mon, items: [] }; weeks.push(w); }
    w.items.push(it);
  });
  return weeks;
}

export function findExclusion(exclusions, slotId, iso) {
  return exclusions.find((e) => (!e.slot_id || e.slot_id === slotId) && (
    (e.kind === "weekday" && e.weekday === pyWeekday(iso)) ||
    (e.kind === "date" && e.date <= iso && iso <= (e.date_to || e.date))
  ));
}

export const endDate = (iso, slot) => (crossesMidnight(slot) ? addDays(iso, 1) : iso);

// Turno attuale: { date, label } — "In corso" se adesso è dentro la fascia, "Oggi" se deve ancora iniziare.
export function currentShift(slot) {
  const { date, time } = romeToday();
  if (crossesMidnight(slot)) {
    if (time < slot.end_time) return { date: addDays(date, -1), label: "In corso" };
    return { date, label: time >= slot.start_time ? "In corso" : "Stasera" };
  }
  if (time >= slot.end_time) return { date: null, label: null };
  return { date, label: time >= slot.start_time ? "In corso" : "Oggi" };
}

function romeOffset(iso, time) {
  const [y, m, d] = iso.split("-").map(Number);
  const [hh, mm] = time.split(":").map(Number);
  const probe = new Date(Date.UTC(y, m - 1, d, hh - 1, mm));
  const name = new Intl.DateTimeFormat("en-US", { timeZone: "Europe/Rome", timeZoneName: "shortOffset" })
    .formatToParts(probe).find((p) => p.type === "timeZoneName")?.value || "GMT+1";
  const mt = name.match(/GMT([+-])(\d+)/);
  return mt ? `${mt[1]}${p2(mt[2])}:00` : "+01:00";
}

export function calendarLinks(iso, slot, who, eyebrow) {
  const end = endDate(iso, slot);
  const title = `Turno ${slot.name} – ${who}`;
  const info = `Turno ${slot.name.toLowerCase()} ${slot.start_time}–${slot.end_time} · ${eyebrow || "Ramo di Mandorlo"}`;
  const compact = (d, t) => `${d.replaceAll("-", "")}T${t.replace(":", "")}00`;
  const google = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${compact(iso, slot.start_time)}/${compact(end, slot.end_time)}&ctz=Europe/Rome&details=${encodeURIComponent(info)}`;
  const s = `${iso}T${slot.start_time}:00${romeOffset(iso, slot.start_time)}`;
  const e = `${end}T${slot.end_time}:00${romeOffset(end, slot.end_time)}`;
  const outlook = `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(title)}&startdt=${encodeURIComponent(s)}&enddt=${encodeURIComponent(e)}&body=${encodeURIComponent(info)}`;
  return { google, outlook };
}
